import { useRef } from "react";

interface OvertimeInputProps {
  initialOvertime: number;
  initialEarlyLeave: number;
  disabled?: boolean;
  /** Fired on blur with the parsed (overtime, earlyLeave) hours. */
  onCommit: (overtimeHours: number, earlyLeaveHours: number) => void;
}

/**
 * Two tiny number inputs for an approved employee in a cell:
 *  - "+TC" overtime hours (tăng ca)
 *  - "−VS" early-leave hours (về sớm)
 * Values are committed on blur so a single typed change persists immediately.
 */
export function OvertimeInput({
  initialOvertime,
  initialEarlyLeave,
  disabled = false,
  onCommit,
}: OvertimeInputProps) {
  const otRef = useRef<HTMLInputElement>(null);
  const vsRef = useRef<HTMLInputElement>(null);

  const commit = () => {
    const overtime = Math.max(0, Number(otRef.current?.value) || 0);
    const earlyLeave = Math.max(0, Number(vsRef.current?.value) || 0);
    onCommit(overtime, earlyLeave);
  };

  return (
    <div className="flex items-center gap-1">
      <input
        ref={otRef}
        type="number"
        step="0.5"
        min="0"
        disabled={disabled}
        defaultValue={initialOvertime || ""}
        onBlur={commit}
        placeholder="+TC"
        title="Tăng ca (giờ)"
        className="w-12 rounded border border-amber-200 px-1 py-0 text-[10px] text-amber-700 placeholder:text-amber-300 disabled:opacity-50"
      />
      <input
        ref={vsRef}
        type="number"
        step="0.5"
        min="0"
        disabled={disabled}
        defaultValue={initialEarlyLeave || ""}
        onBlur={commit}
        placeholder="−VS"
        title="Về sớm (giờ)"
        className="w-12 rounded border border-rose-200 px-1 py-0 text-[10px] text-rose-600 placeholder:text-rose-300 disabled:opacity-50"
      />
    </div>
  );
}
